import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CandidateExtraInfoState } from '@modules/candidate-extra-info/store/candidate-extra-info.reducer';

export const getCandidateExtraInfoState =
  createFeatureSelector<CandidateExtraInfoState>('candidateExtraInfo');

export const selectCandidatesExtraInfoById = (candidateId: number) =>
  createSelector(getCandidateExtraInfoState, (entities) =>
    entities.extraInfoList.filter((extraInfo) => candidateId === extraInfo.candidateId),
  );
